import { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';

export const useIntakes = () => {
  const [intakes, setIntakes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchIntakes = async () => {
    setLoading(true);
    try {
      const { data, error } = await supabase
        .from('intakes')
        .select('*')
        .order('start_date', { ascending: false });
      
      if (error) throw error;
      setIntakes(data || []);
    } catch (error) {
      setError(error.message);
      console.error('Error fetching intakes:', error);
    } finally {
      setLoading(false);
    }
  };

  const addIntake = async (intakeData) => {
    try {
      const { data, error } = await supabase
        .from('intakes')
        .insert([intakeData])
        .select();
      
      if (error) throw error;
      setIntakes(prev => [...prev, data[0]]);
      return { success: true, data: data[0] };
    } catch (error) {
      setError(error.message);
      console.error('Error adding intake:', error);
      return { success: false, error: error.message };
    }
  };

  const updateIntake = async (id, updates) => {
    try {
      const { data, error } = await supabase
        .from('intakes')
        .update(updates)
        .eq('id', id)
        .select();
      
      if (error) throw error;
      setIntakes(prev => prev.map(intake => intake.id === id ? data[0] : intake));
      return { success: true, data: data[0] };
    } catch (error) {
      setError(error.message);
      console.error('Error updating intake:', error);
      return { success: false, error: error.message };
    }
  };

  const deleteIntake = async (id) => {
    try {
      const { error } = await supabase
        .from('intakes')
        .delete()
        .eq('id', id);
      
      if (error) throw error;
      setIntakes(prev => prev.filter(intake => intake.id !== id));
      return { success: true };
    } catch (error) {
      setError(error.message);
      console.error('Error deleting intake:', error);
      return { success: false, error: error.message };
    }
  };

  useEffect(() => {
    fetchIntakes();
  }, []);

  return {
    intakes,
    loading,
    error,
    addIntake,
    updateIntake,
    deleteIntake,
    refetch: fetchIntakes
  };
};